var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ compact: _vm.isCompact, hidden: !_vm.appear },attrs:{"id":"sidebar"},on:{"mouseleave":function($event){return _vm.reduceBar()},"mouseover":function($event){_vm.isCompact = false}}},[_c('SidebarItems',{attrs:{"items":_vm.menu,"isCompact":_vm.isCompact},on:{"open-menu":function($event){return _vm.openMenu()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }